module.exports = __webpack_public_path__ + "static/media/peace-of-mind.cc1d0be3.svg";